import { createSlice } from '@reduxjs/toolkit';
export const remoteInitialState = {
    active: false,
    outbox: [],
    nextId: 1,
    saveState: 'idle',
    connection: 'poll',
    authors: {}
};
const remoteSlice = createSlice({
    name: 'remote',
    initialState: remoteInitialState,
    reducers: {
        setActive: (state, action) => {
            state.active = action.payload;
        },
        record: (state, action) => {
            state.outbox.push({ id: state.nextId, change: action.payload });
            state.nextId += 1;
            if (state.saveState === 'idle' || state.saveState === 'saved') {
                state.saveState = 'pending';
            }
        },
        resume: state => {
            if (typeof state.appliedRevision !== 'number') {
                state.appliedRevision = state.revision;
            }
            state.saveState =
                state.outbox.length > 0
                    ? 'pending'
                    : state.lastSavedAt
                        ? 'saved'
                        : 'idle';
            state.connection = 'poll';
            state.lastOverwrote = [];
        },
        saveStarted: state => {
            state.saveState = 'saving';
        },
        saveSucceeded: (state, action) => {
            const flushed = new Set(action.payload.ids);
            state.outbox = state.outbox.filter(entry => !flushed.has(entry.id));
            state.revision = Math.max(state.revision ?? -1, action.payload.revision);
            if (!action.payload.rebased) {
                state.appliedRevision = Math.max(state.appliedRevision ?? -1, action.payload.revision);
            }
            state.lastSavedAt = action.payload.savedAt;
            state.saveState = state.outbox.length > 0 ? 'pending' : 'saved';
            state.lastError = undefined;
            state.lastOverwrote = action.payload.overwrote || [];
            if (action.payload.authors) {
                state.authors = action.payload.authors;
            }
        },
        saveFailed: (state, action) => {
            state.saveState = action.payload.offline ? 'offline' : 'error';
            state.lastError = action.payload.message;
        },
        remoteHydrated: (state, action) => {
            state.revision = Math.max(state.revision ?? -1, action.payload.revision);
            state.appliedRevision = Math.max(state.appliedRevision ?? -1, action.payload.revision);
            if (typeof action.payload.publishedRevision === 'number') {
                state.publishedRevision = action.payload.publishedRevision;
            }
            if (action.payload.replaceAuthors) {
                state.authors = action.payload.authors || {};
            }
            else if (action.payload.authors) {
                state.authors = { ...state.authors, ...action.payload.authors };
            }
        },
        revisionSeen: (state, action) => {
            state.revision = Math.max(state.revision ?? -1, action.payload.revision);
            state.appliedRevision = Math.max(state.appliedRevision ?? -1, action.payload.revision);
            if (typeof action.payload.publishedRevision === 'number') {
                state.publishedRevision = action.payload.publishedRevision;
            }
        },
        staleAnswerSkipped: state => {
            state.staleAnswers = (state.staleAnswers || 0) + 1;
        },
        objectRestarted: (state, action) => {
            state.revision = action.payload.revision;
            state.appliedRevision = action.payload.revision;
            state.objectRestartedAt = new Date().toISOString();
            if (typeof action.payload.publishedRevision === 'number') {
                state.publishedRevision = action.payload.publishedRevision;
            }
        },
        publishQueued: (state, action) => {
            if (typeof action.payload.revision === 'number') {
                state.publishedRevision = action.payload.revision;
            }
            else if (typeof state.revision === 'number') {
                state.publishedRevision = state.revision;
            }
        },
        connectionChanged: (state, action) => {
            state.connection = action.payload;
        },
        dismissOverwrote: state => {
            state.lastOverwrote = [];
        },
        draftDiscarded: (state, action) => {
            state.outbox = [];
            state.revision = action.payload.revision;
            state.appliedRevision = undefined;
            state.publishedRevision =
                typeof action.payload.publishedRevision === 'number'
                    ? action.payload.publishedRevision
                    : action.payload.revision;
            state.discardedRevision = action.payload.revision;
            state.discardedAt = action.payload.at || new Date().toISOString();
            state.discardedBy = action.payload.by || undefined;
            if (state.saveState === 'pending' ||
                state.saveState === 'error' ||
                state.saveState === 'offline') {
                state.saveState = state.lastSavedAt ? 'saved' : 'idle';
            }
            state.lastError = undefined;
            state.lastOverwrote = [];
        }
    }
});
export const actions = remoteSlice.actions;
export default remoteSlice.reducer;
